import * as sharedActions from '../../../../../shared/store/collections/actions';
import * as api from '../../../utils/api/collections';

export const updateCollection = (params) => sharedActions.updateCollection(api, params);

export const shareWithTeam = (params, creator) => sharedActions.shareWithTeam(api, params, creator);

export const socialShareCollection = (params) => sharedActions.socialShareCollection(api, params);
